import { render, staticRenderFns } from "./Juxtaposition.vue?vue&type=template&id=60143604&scoped=true&"
import script from "./Juxtaposition.vue?vue&type=script&lang=js&"
export * from "./Juxtaposition.vue?vue&type=script&lang=js&"
import style0 from "./Juxtaposition.vue?vue&type=style&index=0&id=60143604&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60143604",
  null
  
)

export default component.exports